import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  margin:2rem;
  justify-content: center;
  align-items: flex-start; 
  box-sizing: border-box;

`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center; 
  width: 100%;
  flex-direction: column;
  margin: auto 0;
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.card};
  padding: 2rem;
  box-shadow: 0 4px 16px ${({ theme }) => theme.colors.shadow};
  width: fit-content;
  max-width: 100%;
  animation: fadeIn 0.5s ease forwards;
  opacity: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-radius:16px;


  @keyframes fadeIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
    from {
      opacity: 0;
      transform: translateY(20px);
    }
  }
`;


export const Label = styled.p`
  margin-bottom: 1rem;
  width: 100%;
  padding: 0.5rem;
  color: ${({ theme }) => theme.colors.text};
`;

export const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid
    ${({ theme, $error }) => ($error ? "red" : theme.colors.lineColor)};
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme, $error }) => ($error ? "red" : theme.colors.text)};
  font-size: 1rem;

   &::placeholder {
    color: ${({ theme, $error }) => ($error ? "red" : theme.colors.lineColor)};
  }

  &:focus {
    outline: none;
    border-color: ${({ $error, theme }) =>
    $error ? "red" : theme.colors.primary};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primary}33;
  }

  option {
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const TextArea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid
    ${({ theme, $error }) => ($error ? "red" : theme.colors.lineColor)};
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme, $error }) => ($error ? "red" : theme.colors.text)};
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;

  &::placeholder {
    color: ${({ theme, $error }) => ($error ? "red" : theme.colors.lineColor)};
  }

  &:focus {
    outline: none;
    border-color: ${({ $error, theme }) =>
    $error ? "red" : theme.colors.primary};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primary}33;
  }
`;

export const Message = styled.p`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.small.size};
  font-weight: ${({ theme }) => theme.typography.small.weight};
  color: ${({ $variant, theme }) =>
    $variant === "success" ? "green" :
      $variant === "error" ? "red" :
        $variant === "warning" ? "orange" :
          theme.colors.primary
  };
  margin-top: 0.5rem;
`;


export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
`;

export const MessageCard = styled.div`
  background-color: ${({ theme }) => theme.colors.card};
  padding: 2rem;
  box-shadow: 0 4px 16px ${({ theme }) => theme.colors.shadow};
  width: fit-content;
  height: fit-content;
  max-width: 90%;
  animation: fadeIn 0.5s ease forwards;
  opacity: 0;
  margin: 2rem;
    border-radius:16px;

  text-align: center;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const FixedCard = styled.div`
  background-color: ${({ theme }) => theme.colors.card};
  padding: 2rem;
  box-shadow: 0 4px 16px ${({ theme }) => theme.colors.shadow};
  margin: 2rem 0;
  border-radius:16px;
  animation: fadeIn 0.5s ease forwards;
  opacity: 0;
  width: ${({ width }) => width || "300px"};
  height: ${({ height }) => height || "200px"};

  @keyframes fadeIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
    from {
      opacity: 0;
      transform: translateY(20px);
    }
  }
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.primary};
`;


export const ProgressWrapper = styled.div`
  background: ${({ theme }) => theme.colors.lineColor}33;
  border-radius: 10px;
  overflow: hidden;
  margin: 1rem 0;
  height: 10px;
  width: 100%;
`;

export const Chip = styled.span`
  display: inline-block;
  padding: 2px 8px;
  margin-right: 4px;
  margin-bottom: 4px;
  background-color: ${({ theme }) => theme.colors.lineColor}33;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  font-size: 0.85rem;
`;

export const ProgressFill = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  height: 100%;
  width: ${props => props.percent}%;
  transition: width 0.3s ease;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

`;

export const ModalCloseButton = styled.button`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: none;
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  &:hover { opacity: 0.85; }
`;

export const Dropdown = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid ${({ theme }) => theme.colors.lineColor};
  border-radius: 6px;
  max-height: 200px;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.card};
  position: absolute;
  z-index: 1000;
  width: 100%;
  margin-top: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

export const DropdownItem = styled.li`
  padding: 8px 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lineColor}33;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.primary}22;
  }
`;
